import { useState, useEffect, useRef } from "react";
import { AccountsEndpoint } from "../../service/Admin";
// import { logoutAccount } from '../../routes/permission';
import MenuContext from "./MenuContext";
import { TOKEN_CLIENT_INFO } from "../../actions/constants";

export default function AdminMenuProvider({ children }) {
  // Info User
  // eslint-disable-next-line no-unused-vars
  const [menus, setMenus] = useState([]);
  const _mountedRef = useRef(false);
  // Call API
  useEffect(() => {
    _mountedRef.current = true;
    // Lấy danh sách các Menu
    AccountsEndpoint.getMenuWithAuthority()
      .then((result) => {
        if (result.isSuccessed) {
          if (
            TOKEN_CLIENT_INFO.mainRole === "CB" &&
            !TOKEN_CLIENT_INFO.isQuanTriDonVi
          ) {
            // Chỉ cán bộ quản trị mới cái menu nhân sự
            _mountedRef.current &&
              setMenus(
                result.resultObj.filter(
                  (item) =>
                    ![
                      "/don-vi/nhan-su/danh-sach-nhan-su",
                      "/don-vi/danh-muc",
                      "/don-vi/chuc-danh",
                    ].includes(item.path),
                ),
              );
          } else {
            _mountedRef.current && setMenus(result.resultObj);
          }
        }
      })
      .catch(() => {});
    // logoutAccount
    return () => {
      _mountedRef.current = false;
    };
  }, []);
  return (
    <MenuContext.Provider value={{ menus }}>{children}</MenuContext.Provider>
  );
}
